export default __webpack_public_path__ + "static/media/jaxrs.b30b026f.png";